
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"7","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.016 10.906c.171-.177.283-.416.336-.719.052-.302.078-.835.078-1.601V6.469c0-.672.101-1.258.304-1.758.209-.505.592-1.057 1.149-1.656H1.875c-1.026 0-1.54-.44-1.54-1.32 0-.449.102-.876.306-1.282h.468c.037.271.13.469.282.594.15.125.382.187.695.187h3.773c.396 0 .67.081.82.243.157.156.235.442.235.859 0 .312-.029.539-.086.68-.057.14-.156.27-.297.39-.338.297-.57.6-.695.906-.125.308-.188.73-.188 1.266v3.813c0 .28-.028.51-.085.687-.053.172-.123.32-.211.445a1.473 1.473 0 01-.32.329c-.12.093-.35.234-.688.421l-.328-.367z","fill":"currentColor"}})])
          )
        }
      }
    